<template>
  <div v-if="user">
    <v-alert style="border-style: none;" :value="true" class="org-alert elevation-2">Algunos organigramas podrían no estar actualizados, dado el contexto de integración</v-alert>
    <breadcrumb v-if="user.length" />
    <div v-else class="breadcrumb">
      <ul>
        <li v-for="(bc, i) in user.breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
          <router-link tag="li" :to="bc.link">
            <div v-if="i === user.breadcrumbs.length -1">
              <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
            </div>
            <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
          </router-link>
        </li>
      </ul>
    </div>

    <ShowUserCardMobile
      v-if="$vuetify.breakpoint.smAndDown"
      :user="user"
      :currentUser="current_user"
    />

    <ShowUserCard
      v-else
      :user="user"
      :currentUser="current_user"
    />

    <OrganizationChartMobile
      v-if="$vuetify.breakpoint.smAndDown"
      :currentUser="user"
      :parents="parents"
      :companyChart="companyChart"
    />

    <ShowOrganizationChart
      v-else
      :parents="user"
      :companyChart="companyChart"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/General/Breadcrumb";
import { mapActions, mapState, mapGetters } from "vuex";
import OrganizationChartMobile from "@/components/User/OrganizationChartMobile";
import ShowOrganizationChart from "@/components/User/ShowOrganizationChart";
import ShowUserCard from "@/components/User/ShowUserCard";
import ShowUserCardMobile from "@/components/User/ShowUserCardMobile";

export default {
  components: {
    Breadcrumb,
    ShowOrganizationChart,
    ShowUserCard,
    ShowUserCardMobile,
    OrganizationChartMobile
  },
  data() {
    return {
      dialog: false,
      message_modal: false,
    };
  },
  computed: {
    ...mapState("user", ["user", "current_user", "companyChart"]),
    ...mapGetters("user", ["parents"]),
  },
  methods: {
    ...mapActions("user", ["fetchUser", "hideCompanyChart"]),
  },
  created() {
    this.hideCompanyChart()
    this.fetchUser(this.$route.params.id)
  }
};
</script>
<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
.org-alert {
  position: relative;
  overflow: hidden;
  background-color: #f5f5f5 !important;
  color: #515151 !important;
  font-size: 1.2em !important;
  font-weight: bold !important;
  border-radius: 8px;
}

.org-alert::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 14px;
  height: 100%;
  background: #d1657b;
}
</style>